export interface QuizQuestion {
  id: string;
  question: string;
  coverImageUrl: string;
  answers: {
    id: string;
    answer: string;
    isAnswer?: boolean;
  }[];
}

export interface QuizQuestionAnswer {
  questionId: string;
  answerId?: string;
  correctAnswerId?: string;
  correct?: boolean;
  showCorrectAnswer?: boolean;
}

export interface QuizDragAndDropQuestion {
  title?: string;
  id: string;
  questions: {
    id: string;
    word: string;
    answerId?: string;
  }[];
  images: {
    id: string;
    imageUrl: string;
  }[];
}

export interface QuizDragAndDropQuestionAnswer {
  questionId: string;
  imageId: string;
  correct?: boolean;
}

export const QuizDraggableActivityItem = 'QuizDraggableActivityItem' as const;
